/**
 * 「URLから読み取る」の引き継ぎ情報 (localStorage) の持ち主。ログイン中のユーザーと組織で保存キーを分け、
 * 同じブラウザで別アカウントにログインしたときに前の利用者の読み取りが復元されないようにする。
 * プロファイル取得前は null (保存も復元もしない)。
 */
import { useMemo } from 'react';
import { useUserProfile } from '../../hooks/useUserProfile';
import type { UrlSummaryResumeScope } from './urlSummary';

export function useUrlSummaryResumeScope(): UrlSummaryResumeScope | null {
  const { data: profile } = useUserProfile();
  const userUid = profile?.user_uid;
  const organizationId = profile?.organization_id ?? null;
  return useMemo(() => (userUid ? { userUid, organizationId } : null), [userUid, organizationId]);
}
